import { callApi } from '@/api/apibase'

export const getGreenCoursePages = function (courseId) {
  var query = courseId ? `?courseId=${courseId}` : ''
  return callApi('GET', `/api/external/greencourse/getPages${query}`, null)
}
